import type { Node } from "@mapcraft-tasks/client-store";
import { useToday } from "@mapcraft-tasks/client-store/react";
import { isTerminal } from "@mapcraft-tasks/domain";

/**
 * Срок одной и той же плашкой везде: строка аутлайна, панель фокуса, секция пинов.
 * Просрочка красная, у терминальных гасится — иначе выполненная вчерашняя задача
 * кричала бы тем же красным, что и живая просроченная.
 */
export function DateBadge({ node, className = "" }: { node: Node; className?: string }) {
	const today = useToday();
	if (!node.scheduledDate) {
		return null;
	}
	const overdue = node.scheduledDate < today && !isTerminal(node.status);
	const tone = overdue ? "text-danger" : isTerminal(node.status) ? "text-ink-faint" : "text-ink-muted";
	return (
		<span className={`tabular shrink-0 text-2xs ${tone} ${className}`}>{shortDate(node.scheduledDate, today)}</span>
	);
}

export function shortDate(date: string, today: string): string {
	if (date === today) {
		return "сегодня";
	}
	const [, m, d] = date.split("-");
	return `${d}.${m}`;
}
